import { waitSeconds } from "../../utils/utilitiesmodule";
import "../../utils/messages";
import { LICENSES_NOT_RETRIEVED, COMPANY_NOT_UPDATED, EVENTS_MESSAGES, EMAILPROVIDERS_NOT_RETRIEVED, PRICING_NOT_RETRIEVED, USER_MESSAGES, SESSIONS_MESSAGES, COCOD_ERROR_CRYPT, STRING_ERROR_CRYPT, LIC_EXT_INFO_ERR, TYPES_NOT_RETRIEVED, ERROR } from "../../utils/messages";
import moment from "moment";
import router from "..";
import { ClientMessage } from "../../utils/objects";

export function assignMiscRequests(api) {
    /********************************************DASHBOARD - EVENTS**********************************************************************/
    api.getEvents = async function () {
        var response = await api.get('/enterprise/events', this.buildConfig())
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    this.createToastFunction(this.translateFunction(EVENTS_MESSAGES.EVENTS_NOT_RETRIEVED), "alert");
                    return [];
                }

                return res.data;
            }).catch(e => {
                this.checkError(e, EVENTS_MESSAGES.EVENTS_NOT_RETRIEVED);
                return [];
            });

        return response;


    }

    api.getEventsTypes = async function () {
        var response = await api.get("enterprise/events/types", this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, TYPES_NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.setAllReadEvents = async function (eventsID) {
        var body = {
            "ids": eventsID,
            "value": "1"
        };
        var response = await api.put("enterprise/events/read", body, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, EVENTS_MESSAGES.EVENTS_READED);
                return null;
            });

        return response;
    }


    /********************************************IPERIUS REMOTE - SESSIONI**********************************************************************/
    // sessioni e statistiche di Iperius Remote
    api.getSessions = async function (stats) {

        var body = {
            'id_group': stats.id_group,
            'id_user': stats.id_user, //stats["id_user"],
            'dt_inf': moment(stats.dt_inf).format("YYYYMMDDhhmmss"),
            'dt_sup': moment(stats.dt_sup).format("YYYYMMDDhhmmss"),
            'id_host': stats.id_host,
            'order_by_idhost': stats.order_by_idhost,
            "include_stats": stats.include_stats ? stats.include_stats : "1"
        };

        var response = await api.put('/sessions', body, this.buildConfig())
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    this.createToastFunction(this.translateFunction(SESSIONS_MESSAGES.LIST_NOT_RETRIEVED), "alert");
                    return [];
                }

                return res.data;
            }).catch(e => {
                this.checkError(e, SESSIONS_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.getSessionsLight = async function () {

        var response = await api.get('/sessions?limit=30', this.buildConfig())
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    this.createToastFunction(this.translateFunction(SESSIONS_MESSAGES.LIST_NOT_RETRIEVED), "alert");
                    return [];
                }

                return res.data;
            }).catch(e => {
                this.checkError(e, SESSIONS_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;



    }

    /********************************************LICENSE**********************************************************************/

    api.getLicenses = async function () {
        var response = await api.get("/licenses/", this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, LICENSES_NOT_RETRIEVED);
                return null;
            });

        return response;
    }
    //[TG - 18/06/2024 - informazioni aggiuntive sulla licenza corrente]
    //Veronica - 16/01/2025 : L'id della licenza viene preso direttamente dal token
    //altrimenti veniva recuperato this.$session.getLicense().id.
    //Per sicurezza, ho creato il metodo getLicenseExtendedInfoByID
    api.getLicenseExtendedInfo = async function () {
        var response = await api.get('/enterprise/license', this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, LIC_EXT_INFO_ERR);
                return null;
            });

        return response;
    }

    api.getLicenseExtendedInfoByID = async function (idLicense) {

        var response = await api.get('/enterprise/license?id=' + idLicense, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, LIC_EXT_INFO_ERR);
                return null;
            });

        return response;
    }

    api.updateMasterAccountCompany = async function (company) {
        var body = {
            ma_newcompany: company
        };
        var response = await api.put('/masteraccounts/company', body, this.buildConfig())
            .then(() => true)
            .catch(e => {
                this.checkError(e, COMPANY_NOT_UPDATED);
                return false;
            });

        return response;
    }

    /***********************************************AUDIT********************************************************************/
    api.getAuditLogs = async function (filters) {
        var query = JSON.parse(JSON.stringify(filters));
        query.dt_inf = query.dt_inf.replace(/-/g, "") + "000000";
        query.dt_sup = query.dt_sup.replace(/-/g, "") + "235959";
        var filtersToString = new URLSearchParams(query).toString();
        var response = await api.get("/enterprise/audit/logs?" + filtersToString, this.buildConfig())
            .then(res => {
                if ([null, ""].includes(res.data)) {
                    return { has_more: false, logs: [] };
                }
                return res.data;
            }).catch(e => {
                this.checkError(e, ERROR);
                return { has_more: false, logs: [] };
            });
        return response;
    }

    /*
    {
    "id_activity": 2,
    "id_user": "138a2a2d-0b4b-4fff-911f-1eb74a71889a",
    "args": {"ID_USER":"aaaaaaaaa", "ID_GROUP":"bbbbbbb"}
    }
    */
    api.createAuditLog = async function (newAudit) {
        var response = await api.post("/enterprise/audit/logs", newAudit, this.buildConfig())
            .then(() => {
                return true;
            }).catch(e => {
                this.checkError(e, ERROR);
                return false;
            });
        return response;
    }

    api.getAuditCategories = async function () {
        var response = await api.get("/enterprise/audit/categories", this.buildConfig())
            .then(res => {
                if ([null, ""].includes(res.data)) {
                    return [];
                }
                return res.data.categories;
            }).catch(e => {
                this.checkError(e, ERROR);
                return [];
            });
        return response;
    }
    /*********************************SOFTWARE INVENTORY******************************************************************/
    api.getSoftwareList = async function (idPC) {
        //idPC = "305489b6-6fff-4c0f-86da-1052377b44c0";

        var result = await api.get("/enterprise/swinventory?id_computer=" + idPC, this.buildConfig())
            .then(res => {
                if ([null, ""].includes(res.data)) {
                    return {
                        sw_inventory: [],
                        dt_last_scan_utc: null
                    };
                }
                return res.data;
            }).catch(e => {
                this.checkError(e, ERROR);
                return {
                    sw_inventory: [],
                    dt_last_scan_utc: null
                };
            });
        return result;
    }


    /********************************************ALTRO**********************************************************************/

    api.getPricing = async function (license) {

        var response = await api.post('enterprise/license/configure/', license, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, PRICING_NOT_RETRIEVED);
                return null;
            });

        return response;
    }

    api.getEmailProviders = async function () {

        var response = await api.get('/enterprise/smtp', this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, EMAILPROVIDERS_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    //export const agentAPI = {
    //[TG - 18/06/2024 - hash stringa codice controllo]
    api.getCoCod = async function (valore) {
        var data = {
            'str': valore,
        };

        var response = await api.put('/enterprise/utils/hash', data, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, COCOD_ERROR_CRYPT);
                return null;
            });

        return response;
    }

    //[TG - 18/06/2024 - crypt stringa per parametro]
    api.getCrio = async function (valore) {
        var data = {
            'str': valore,
        };

        var response = await api.put('/enterprise/utils/crypt', data, this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, STRING_ERROR_CRYPT);
                return null;
            });

        return response;
    }



    api.hasSQLServer = async function (idPC) {
        var response = await api.get("/enterprise/systeminfos?id=41&pc=" + idPC, this.buildConfig())
            .then(res => {
                if ([null, ""].includes(res.data.info_value)) {
                    return false;
                }
                return true;
            }).catch(e => {
                this.checkError(e, ERROR);
                return false;
            });
        return response;
    }



    /********************************************UTILS*********************************************************************/
    api.buildConfig = function (baseurl = process.env.VUE_APP_BASE_URL) {

        var config = {
            baseURL: baseurl
        };

        var accessToken = this.vueEnvironment.$root.authObj?.access_token

        if (accessToken != null)
            config.headers = {
                //"Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Bearer " + accessToken
            }

        return config;
    }


    api.buildConfigTFA = function () {

        return {
            headers: {
                //"Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Bearer " + this.vueEnvironment.$root.authObj.access_token,
                //"redirect": 1,
                "Content-Type": "application/json",
            }
        };
    }



    /***********************CUSTOM REQUEST TO SERVER******************************************************/
    api.sendRequestToServer = async function (method, url, headers, body = null, message_before = null, message_ok = null, message_failed = null, waitNSeconds = null, command) {
        var serverURL = process.env.VUE_APP_BASE_URL + "/iperius/ccall";
        var serverHeaders = api.buildConfig()
        var serverBody = {
            "crc": "",// in futuro conterrà un codice di sicurezza
            "url": url,
            "method": method,
            "headers": headers,
            "body": body//??defaultHeaders
        };

        //if (body!=null) {
        //    serverBody.body=body;
        //}

        var ok = false, response = null, realResp;
        if (message_before != null) {
            console.debug(message_before);
            api.emitFunction("sendClientMessage", ClientMessage.wait(message_before), command);
        }

        [ok, response] = await api.post(serverURL, serverBody, serverHeaders)
            .then(serverResp => {
                console.debug(serverResp);
                serverResp = serverResp.data;

                if (method == "HEAD") {
                    return [true, serverResp.headers];
                }

                ok = 200 <= serverResp.status_code && serverResp.status_code < 300;
                if (!ok && serverResp.body.error != undefined) {
                    if (serverResp.body.error.code != undefined && serverResp.body.error.message != undefined) {
                        console.writeError(serverResp.body.error.code + " : " + serverResp.body.error.message);
                    }
                    return [false, serverResp.body.error];
                }

                if (!ok && typeof serverResp.body == 'string' && serverResp.body.contains("<Error>")) {
                    console.writeError(serverResp.body);
                    return [false, null];
                }

                if (!ok && serverResp.body.error == undefined) {
                    console.writeError(serverResp.body);
                    return [false, serverResp.body];
                }


                realResp = serverResp.body;
                if (typeof realResp == "string" && realResp.contains("underconstructions")) {
                    return [false, "CHANGEURL"]
                }

                if (typeof realResp == "string") {
                    return [true, realResp];
                }

                if (realResp.status_code == undefined) {
                    console.debug(realResp)
                    return [true, realResp];
                }

                ok = 200 <= realResp.status_code && realResp.status_code < 300;
                if (!ok) {
                    console.writeError(realResp.body);
                    return [false, null];
                }

                return [true, realResp.body];
            }).catch(e => {
                console.writeError(e);
                return [false, e];
            });

        if (!ok && message_failed != null) {
            console.writeError(message_failed);
            api.emitFunction("sendClientMessage", ClientMessage.error(message_failed, null, command, false), command);
        }

        if (ok && message_before != null && waitNSeconds != null) {
            for (var s = waitNSeconds; s >= 0; s--) {
                api.emitFunction("sendClientMessage",
                    ClientMessage.wait_translated(
                        api.translateFunction(message_before) + ". " + api.translateFunction("Wait {0} seconds", [s]),
                        [s],
                        command
                    ),
                    command
                );
                await waitSeconds(1);
            }
        }

        if (ok && message_ok != null) {
            console.debug(message_ok);
            api.emitFunction("sendClientMessage", ClientMessage.success(message_ok, null, command, false), command);
        }

        return [ok, response];
    }

    api.checkErrorDescriptions = function (e) {
        var errors_descriptions = null;
        if (e.data && e.data.errors && Array.isArray(e.data.errors)) {
            const errorMessages = e.data.errors
                .map(error => typeof error === "string" ? error : error && error.message)
                .filter(errorMessage => typeof errorMessage === "string" && errorMessage != "");
            if (errorMessages.length > 0) {
                errors_descriptions = errorMessages.map(errorMessage => this.translateFunction(errorMessage));
            }
        }

        if (e.data && e.data.error) {
            errors_descriptions = [this.translateFunction(e.data.error)];
        }

        if (e.data && e.data.message && e.data.message != '') {
            errors_descriptions = [this.translateFunction(e.data.message)]
        }

        if (errors_descriptions == null) {
            return "";
        }

        return "\n" + errors_descriptions.join("\n");

    }

    api.checkError = function (e, customizedErrorMessage = null, customizedErrorMessage_args = null, seeToast = true) {
        //token scaduto
        if (e.status == 401) {
            sessionStorage.clear();
            localStorage.removeItem("AUTH")
            window.location.href = "/";
            router.replace('/login');
            return;
        }

        //console.writeError(e);
        var errorMessage = "";//e.config.url + "    ";
        if (e.status == null || e.code == "ERR_NETWORK") {
            errorMessage += this.translateFunction(USER_MESSAGES.NOT_CONNECTED);
        } else if (customizedErrorMessage != null && customizedErrorMessage_args != null) {
            errorMessage += this.translateFunction(customizedErrorMessage, customizedErrorMessage_args);
        } else if (customizedErrorMessage != null) {
            errorMessage += this.translateFunction(customizedErrorMessage);
        }

        errorMessage = errorMessage.trimEnd(".");
        errorMessage += this.checkErrorDescriptions(e);

        if (errorMessage != "") {
            if (seeToast) {
                this.createToastFunction(errorMessage, "alert");
                console.writeError(e.config.url + "    " + errorMessage);
            }
            const clientMessage = ClientMessage.error_translated(errorMessage);
            return clientMessage;
        }
    }


    //non serve
    /* api.getSavedAccessToken = function() {
        var accessToken = isValid(this.accessToken) ?
            this.accessToken :
            JSON.parse(localStorage.getItem("AUTH")) != null ?
            JSON.parse(localStorage.getItem("AUTH")).access_token :
            this.vueEnvironment.$session.exists() && this.vueEnvironment.$session.has("AUTH") ?
            this.vueEnvironment.$session.getAuth().access_token :
            null;
 
        if (accessToken != null) {
            this.accessToken = accessToken;
        } else {
            console.log("ATTENZIONE : nessun accessToken salvato!!!")
        }
        return accessToken;
    } */
}
